import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useComponentTranslation } from "@/services/i18n";
import toast from "react-hot-toast";
import { FiCopy, FiCheck, FiCode, FiArrowLeft } from "react-icons/fi";

const translations = {
  en: {
    title: "Raw Data",
    description: "View the complete job data in JSON format",
    copy_button: "Copy JSON",
    copied: "Copied!",
  },
  fr: {
    title: "Données Brutes",
    description: "Voir les données complètes du poste au format JSON",
    copy_button: "Copier JSON",
    copied: "Copié !",
  },
};

export default function RawData({ job }) {
  const { t } = useComponentTranslation(translations);
  const { id } = useParams();
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      const jsonString = JSON.stringify(job, null, 2);
      await navigator.clipboard.writeText(jsonString);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
      toast.success(t("copied"));
    } catch (e) {
      toast.error(e.code);
    }
  };

  return (
    <div className="p-6">
      {/* Back Button */}
      <button
        onClick={() => navigate(`/recruiter/job-ads/${id}`)}
        className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-6 transition-colors"
      >
        <FiArrowLeft className="w-5 h-5" />
        <span className="font-medium">Back</span>
      </button>

      <div className="bg-white border border-gray-200 rounded-xl p-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
              <FiCode className="w-6 h-6 text-blue-600" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-900">{t("title")}</h2>
              <p className="text-sm text-gray-600 mt-1">{t("description")}</p>
            </div>
          </div>
          <button
            onClick={handleCopy}
            className="flex items-center gap-2 px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors"
          >
            {copied ? (
              <>
                <FiCheck className="w-4 h-4" />
                <span>{t("copied")}</span>
              </>
            ) : (
              <>
                <FiCopy className="w-4 h-4" />
                <span>{t("copy_button")}</span>
              </>
            )}
          </button>
        </div>

        <div className="relative">
          <pre className="bg-gray-900 text-gray-100 p-6 rounded-lg overflow-auto max-h-[calc(100vh-300px)] text-sm font-mono">
            {JSON.stringify(job, null, 2)}
          </pre>
        </div>
      </div>
    </div>
  );
}

